import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from "app/service/authentication.service";

@Component({
  selector: 'app-admin-footer',
  templateUrl: './admin-footer.component.html',
  styleUrls: ['./admin-footer.component.css']
})
export class AdminFooterComponent implements OnInit {

  constructor(public authenticationService: AuthenticationService) { }

  ngOnInit() {
  }

  isSignedInAdmin(): boolean {
    return this.authenticationService.isSignedInAdmin();
  }

}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/admin-footer/admin-footer.component.ts